export default __webpack_public_path__ + "static/media/12.0c969b74.png";